import { gql } from '@apollo/client'
import { MOD_COM_ACTUAL_FACING } from './ModComActualFacing'

export const SHELF_COMPLIANCE_GROUP_FRAGMENT = gql`
  fragment ShelfComplianceGroup on ShelfComplianceGroup {
    id
    strictScore
    sequenceScore
    shelf {
      isUnderShelf
      yOffset
      depth
      displayShelfNumber
      segmentShelfNumber
    }
    productScores {
      upc
      totalProductFullness
      requiredVerticalFacings
      requiredFacingsCount
      compliantFacingsCount
      totalAvailableProducts
    }
    facingScores {
      upc
      score
      issue
      resolved
      actuals {
        ...ModComActualFacing
      }
    }
  }
  ${MOD_COM_ACTUAL_FACING}
`
